// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottombar_text1 {\r\n    font-family: \"Antonio-Regular\" !important;\r\n    font-size: 1.5vw!important;\r\n  }\r\n  .bottombar_text2 {\r\n    font-family: \"Antonio-Regular\" !important;\r\n    font-size: 1.5vw!important;\r\n  }\r\n  .bottombar_text3 {\r\n    font-family: \"Antonio-Regular\" !important;\r\n    font-size: 1.5vw!important;\r\n  }", ""]);
// Exports
module.exports = exports;
